import { render, staticRenderFns } from "./login-captcha.vue?vue&type=template&id=55aa81e2&scoped=true&"
import script from "./login-captcha.vue?vue&type=script&lang=js&"
export * from "./login-captcha.vue?vue&type=script&lang=js&"
import style0 from "./login-captcha.vue?vue&type=style&index=0&id=55aa81e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55aa81e2",
  null
  
)

export default component.exports